<template>
     <div class="container">
         <router-view :key="key" />
     </div>
</template>
<script>
	export default {
		name: 'fullscreen',
		data () {
			return {
				key() {
					return this.$route.path
				}
			}
		}
	}
</script>

<style lang="css" scoped>
.container{width: 100%;max-width: 1920px;margin:auto}
</style>


// WEBPACK FOOTER //
// src/layout/fullscreen.vue